var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidAndIOs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1358 25C61.2333 25 89.3307 25 117.428 25C117.545 25.0811 117.653 25.2161 117.788 25.2432C122.549 26.2698 125.735 30.7277 125.717 36.1942C125.627 79.1518 125.672 122.109 125.663 165.067C125.663 171.83 121.505 176 114.755 176C88.4757 176 62.1963 176 35.9258 176C35.5298 176 35.1428 176 34.7468 175.991C32.6228 175.928 30.7239 175.207 29.0319 173.929C26.143 171.722 25.036 168.696 25.009 165.175C25 163.554 25.009 161.933 25.009 160.312C25 119.029 25.009 77.7469 25 36.4554C25 33.3123 25.504 30.2684 27.9339 28.116C29.4279 26.8102 31.3899 26.0267 33.1358 25ZM70.2511 125.82C68.2711 125.82 66.3632 125.685 64.4822 125.856C62.0883 126.072 60.2433 128.368 60.2883 130.773C60.3333 133.259 62.3133 135.582 64.7522 135.609C71.8171 135.69 78.8909 135.69 85.9558 135.609C88.3407 135.582 90.2397 133.475 90.3657 131.088C90.5187 128.206 88.7187 126.018 85.8388 125.802C84.0568 125.667 82.2569 125.775 80.4209 125.775V114.599C81.0779 114.734 81.6449 114.842 82.2119 114.977C86.8198 116.085 91.2567 115.607 95.5136 113.527C103.28 109.753 107.159 101.243 104.729 93.1017C103.748 89.8146 101.885 86.9688 99.7345 84.3301C93.7046 76.9274 86.1718 71.2987 78.2069 66.1925C76.227 64.9226 74.184 65.0487 72.2671 66.3546C69.5491 68.2007 66.8132 70.0289 64.2032 72.0282C58.4883 76.387 53.0704 81.079 49.0205 87.1129C46.0776 91.4897 44.3676 96.1817 45.6816 101.549C47.9045 110.663 56.6704 116.634 65.9762 115.382C67.3982 115.193 68.8111 114.914 70.2691 114.671V125.811L70.2511 125.82Z",
    fill: "url(#paint0_linear_70_599)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.788 37.1396C141.062 38.6436 146.273 39.8504 151.286 41.6335C155.911 43.2816 158.062 48.577 156.676 53.7733C151.916 71.6588 147.128 89.5353 142.34 107.421C140.324 114.941 138.299 122.46 136.283 129.98C136.175 130.395 136.049 130.809 135.788 131.196V37.1396Z",
    fill: "url(#paint1_linear_70_599)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.723 66.2824C166.486 68.0025 169.222 69.3894 171.589 71.2446C175.477 74.3066 176.053 79.7011 173.299 84.4741C164.947 98.9734 156.577 113.464 148.217 127.954C147.758 128.747 147.281 129.53 146.597 130.233C152.284 109.006 157.972 87.7793 163.732 66.2734L163.723 66.2824Z",
    fill: "url(#paint2_linear_70_599)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_70_599",
    x1: 75.3585,
    y1: 25,
    x2: 75.3585,
    y2: 176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_70_599",
    x1: 146.44,
    y1: 37.1396,
    x2: 146.44,
    y2: 131.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_70_599",
    x1: 160.803,
    y1: 66.2734,
    x2: 160.803,
    y2: 130.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 151,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidAndIOs);
export default __webpack_public_path__ + "static/media/Android_and_iOS.b8959c84672c8a7caf2a4998baa74f20.svg";
export { ForwardRef as ReactComponent };